import { render, staticRenderFns } from "./MU.vue?vue&type=template&id=19be9ef2"
import script from "./MU.vue?vue&type=script&lang=js"
export * from "./MU.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports